
<template>
    <div class="center">
      <vs-dialog v-model="active" width="750px">
        <template #header>
          <h4 class="not-margin">
            {{ codigo }}
          </h4>
        </template>


        <div class="con-form" v-if="codigo">
            <vs-row>
                <vs-col sm="12" lg="6" class="text-center">
                    <p>Docente: <strong>{{ row.docente }}</strong></p>
                </vs-col>
                <vs-col sm="12" lg="6" class="text-center">
                    <p><strong>{{ row.periodo }}</strong></p>
                </vs-col>
            </vs-row>
            <div v-for="(cod, i) in row.codigos_sesiones[codigo]" :key="i" :class="row.codigos_sesiones[codigo].length > 1 ?'divisionLineas' : ''">
                <vs-row>
                    <vs-col sm="12" lg="6">
                        <p class="mb-0"><small>ALUMNO</small></p>
                        <p class="mb-0"><strong>{{ cod.alumno }}</strong></p>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <p class="mb-0"><small>CALIFICACIÓN</small></p>
                        <p class="mb-0"><strong>{{ cod.calificacion }}</strong></p>
                    </vs-col>
                </vs-row>
            </div>
        </div>

        <template #footer>
          <div class="footer-dialog">
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
    export default {
        props:[
            'value',
            'row',
            'codigo'
        ],
        data:() => ({
            active: false,
        }),
        methods:{
        },
        watch: {
            value (val) {
                this.active = val
            },    
            async active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
</script>

<style scoped>

.divisionLineas:not(:last-child){
    border-bottom: 1px solid #E5E7E9; 
}
.divisionLineas{
    padding: 2% 0;
}
</style>